// TODO sections commented waiting for back-end functionality
// import sideBarOptions from '@/modules/RegistryModule/sideBar/request/sideBarOptions'
import { find } from 'lodash'
/* import customFilterResource from '@/api/resources/ui/CustomFilterResource' */
import customConfigResource from '@/api/resources/ui/CustomConfigResource'

class LaboratorySideBarStore {
    constructor() {
        this.loadedCustomOptions = false
        this.loadedConfig = false
        this.state = {
            componentCode: 'uicomponent.laboratory.sidepanel',
            componentCodeLock: 'uicomponent.laboratory.sidepanel.lock',
            selectedOption: null,
            sideBarName: 'expandedLaboratory',
            gridRouteName: 'requestGrid',
            cardIndexRouteName: 'registryRequestCardIndex',
            customOptions: [],
            config: this.getDefaultConfig(),
            sectionIds: []
        }
    }
    getDefaultConfig() {
        return {
            defaultOptionId: null,
            sideBarName: null
        }
    }
    selectFallbackOption() {
        if (this.state && this.state.customOptions.length) {
            this.setSelectedOption(this.state.customOptions[0])
        } else {
            this.setSelectedOption(null)
        }
    }
    hasLoaded() {
        return this.loadedCustomOptions && this.loadedConfig
    }
    selectDefaultOption() {
        const option = this.findOptionById(this.state.config.defaultOptionId)
        if (!option) {
            console.warn(`customOption with id ${this.state.config.defaultOptionId} does not exist, selecting fallback option`)
            this.selectFallbackOption()
            return
        }
        this.setSelectedOption(option)
    }
    findOptionById(id) {
        const predicate = o => o.id === id
        return find(this.completeArray, predicate) || find(this.state.customOptions, predicate)
    }
    setSelectedOption(option) {
        this.state.selectedOption = option
    }
    setSectionIds(sectionIds) {
        this.state.sectionIds = sectionIds
    }
    setDefaultOption(option) {
        this.state.config.defaultOptionId = option && option.id
    }
    async loadConfig() {
        const customConfig = await customConfigResource.get(this.state.componentCodeLock)
        if (customConfig) {
            this.setConfig({ ...this.getDefaultConfig(), ...customConfig.config })
        } else {
            this.setConfig(this.getDefaultConfig())
        }
        this.loadedConfig = true
    }
    setConfig(config) {
        this.state.config = config
    }
    async saveConfig() {
        const config = {
            ...this.state.config,
            sideBarName: this.state.sideBarName
        }
        await customConfigResource.save(this.state.componentCodeLock, config)
        this.state.config = config
    }
}

export default new LaboratorySideBarStore()
